<script lang="ts">
  import type { Snippet } from 'svelte'
  import type { HTMLButtonAttributes } from 'svelte/elements'

  type Props = HTMLButtonAttributes & {
    children: Snippet
    size?: 'sm' | 'icon'
    active?: boolean
  }
  let { children, active = false, size = 'sm', ...rest }: Props = $props()
</script>

<button class={size} aria-disabled={active ? 'true' : undefined} {...rest}>
  {@render children?.()}
</button>

<style lang="scss">
  button {
    min-height: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.5rem;
    border-radius: 0.25rem;
    cursor: pointer;
    font-size: 0.75rem;
    border: 1px solid transparent;
    color: var(--sort-button-foreground);
    background: var(--sort-button-background);

    &.icon {
      padding: 0;
      min-height: 2rem;
      width: 2rem;
    }

    &[aria-disabled='true'] {
      background: var(--sort-button-active-background);
      border-color: var(--sort-button-active-border);
      pointer-events: none;
    }

    &:hover {
      background: var(--sort-button-hover-background);
    }

    &:focus-visible {
      outline: 1px solid var(--stroke);
      outline-offset: 2px;
    }

    &:disabled {
      background: var(--sort-button-disabled-background);
      color: var(--sort-button-disabled-foreground);
      cursor: not-allowed;
      border-color: transparent;
    }

    :global(svg) {
      width: 1.25rem;
      height: 1.25rem;
    }
  }
</style>
